import { render, staticRenderFns } from "./AngleChart.vue?vue&type=template&id=1ad0a22c&"
import script from "./AngleChart.vue?vue&type=script&lang=js&"
export * from "./AngleChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports